// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --blue: #1394ff;
  --black: #282828;
  --gray: #e2e4e6;
  --dark-gray: gray;
  --white: #ffffff;
  --light-gray: #d3d3d3;
  --orange: #ff8f00;
  --bg-color: var(--white);
  --header_height: 60px;
  --header_bg_color: var(--black);
  --header_font_color: white;
  --autocomplete_btn_search_bg_color: var(--blue);
  --autocomplete_btn_search_font_color: white;
  --autocomplete_box_height: 40px;
  --theme: var(--blue);
  --rating-bar-color: #3c3b3b;
  --btn-color: var(--black);
  --address_desc_color: #afafaf;
  --address_title_color: #333;
  --address_bg_color: white;
  --fill_color_svg_mobile: #9A9A9A;
  --stroke_color_svg_mobile: white;
}

.footer {
  font-family: "Inter", sans-sarif;
  padding: 15px 40px;
  color: #2c2c2c;
  vertical-align: middle;
  margin-top: -7px;
  position: fixed;
  width: 100%;
  z-index: 200;
  left: 0;
  bottom: 0;
  font-size: 13px;
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.08);
  background-color: #ffffff;
}
.footer .dFlex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.footer .gotItButton {
  border-radius: 4px !important;
  background-color: #2396ff;
  border: 1px solid #2396ff;
  color: #fff !important;
  font-size: 13px;
  font-weight: normal;
  text-decoration: none;
  margin-right: 12px;
  margin-left: 13px;
}
.footer p {
  margin-top: 0px;
  margin-bottom: 0px !important;
  font-family: "Inter", sans-sarif;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.1px;
  color: #4a4a4a;
}
.footer a {
  cursor: pointer;
}

@media only screen and (max-width: 768px) {
  .hide-mobile-view {
    display: none;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
